import React from 'react';

import {GridDataTable} from '../GridDataTable';

import {useAppSelector} from '../../app/hooks';
import {translationSelector} from '../../slices/translation';

type Context = TranslationIndex.Context

const numberCellStyleObj: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row-reverse',
  alignContent: 'flex-start',
}

type ContextListProps = {
  onEditContext: (contextId: string) => void
}

export const ContextList = ({onEditContext}: ContextListProps) => {
  const {
    contexts,
    filteredList,
    wordCount,
  } = useAppSelector(translationSelector)

  return (
    <GridDataTable
      columns={[
        {
          template: '1fr',
          title: 'Context',
          renderCell: ({ label, id}: Context) => (
            <div style={{ cursor: 'pointer' }} onClick={() => onEditContext(id)}>{label}</div>
          ),
          sortCell: (a: any, b: any) => a.label?.localeCompare(b.label),
        },
        {
          title: 'Modified',
          renderCell: ((item) => new Date(item.modified).toLocaleDateString()),
          sortCell: (a: any, b: any) => a.modified?.localeCompare(b.modified),
        },
        {
          title: 'TR U',
          renderCell: (item) => item.trs[1] ? <span style={{ color: 'red' }}>{item.trs[1]}</span> : 0,
          sortCell: (a: any, b: any) => !!(a.trs[1] - b.trs[1]),

        },
        {
          title: 'TR W',
          renderCell: (item) => item.trs[2] ? <span style={{ color:'#fbcb12'}}>{item.trs[2]}</span> : 0,
          sortCell: (a: any, b: any) => !!(a.trs[2] - b.trs[2]),
        },
        {
          title: 'Items',
          renderCell: ({translations}: Context) => (
            <div style={numberCellStyleObj}>{Object.keys(translations).length}</div>
          ),
        },
        {
          title: `Words (${wordCount})`,
          renderCell: ({wordCount}: Context) => (
            <div style={numberCellStyleObj}>{wordCount}</div>
          ),
        },
      ]}

  data={filteredList.map((id: string) => contexts[id])}
    />
  )
}
